/*** IMPORTS FROM imports-loader ***/
var define = false;

import BackButton from "../util/BackButton";

export default {
  init() { },

  finalize() {
    BackButton.init();
  },
};

